import _ from 'underscore';
import Backbone from 'backbone';
import NavigationUtil from 'utils/NavigationUtil';
var Features = {
        POPULARITY_ROUTING: 'POPULARITY_ROUTING',
        INSIGHTS: 'INSIGHTS',
        UPLOAD: 'UPLOAD',
        STRAVA: 'STRAVA',
        GARMIN_COACH_ATP: 'ADAPTIVE_TRAINING_PLAN',
        MYFITNESSPAL: 'MY_FITNESS_PAL',
        CONNECT_PRIVACY: 'CONNECT-PRIVACY',
        GOLF_PRIVACY: 'GOLF-PRIVACY',
        PRODUCT_IMPROVEMENT_DATA_USAGE: 'PRODUCT_IMPROVEMENT_DATA_USAGE'
    },
    UserOptions = {
        OPT_IN: 'opt-in',
        OPT_OUT: 'opt-out'
    },
    FEATURE_ENDPOINT = '/gdprconsent-service/feature/';

var Feature = Backbone.Model.extend({
    url: function() {
        return FEATURE_ENDPOINT + this.feature;
    },

    backend: 'gcapi',

    initialize: function(args) {
        this.feature = args.feature;

        if (_.isUndefined(this.feature)) {
            throw 'feature is required';
        }

        if (!this.containsFeature(this.feature)) {
            throw 'Unknown feature ' + this.feature;
        }
    },

    save: function(attrs, options) {
        var opts = options || {},
            attrs = attrs || this.attributes,
            url =
                FEATURE_ENDPOINT +
                (this.get('userOption') === UserOptions.OPT_IN ? 'optin/' : 'optout/') +
                this.feature;
        opts.url = url;

        opts.type = 'POST';
        opts.data = attrs;
        opts.contentType = 'application/json';
        this.sync('save', this, opts);
    },

    containsFeature: function(feature) {
        var value = undefined;
        for (var p in Features) {
            if (Features.hasOwnProperty(p)) {
                value = Features[p];
                break;
            }
        }
        return !_.isUndefined(value);
    }
});

Feature.UserOptions = UserOptions;
Feature.Features = Features;
export default Feature;
